import axios from 'axios'
import config from '../../config/config'

const { apiUrl } = config

const httpClient = (params = {}) => {
  const options = params
  if (!params.headers) {
    options.headers = { Accept: 'application/json' }
  }
  options.headers.Authorization = `Bearer ${localStorage.getItem('accessToken')}`
  return axios(options).catch((err) => {
    if (
      err.response.data.statusCode === 401
      && err.response.data.code === 'EXPIRED_TOKEN'
      && localStorage.getItem('accessToken')
      && localStorage.getItem('refreshToken')
    ) {
      return axios
        .post(`${apiUrl}/auth/refresh`, {
          accessToken: localStorage.getItem('accessToken'),
          refreshToken: localStorage.getItem('refreshToken'),
        })
        .then((response) => {
          localStorage.setItem('accessToken', response.data.accessToken)
          localStorage.setItem('refreshToken', response.data.refreshToken)
          localStorage.setItem('authority', response.data.authority)
          options.headers.Authorization = `Bearer ${localStorage.getItem('accessToken')}`

          return axios(options).then()
        })
        .catch(() => {
          // eslint-disable-next-line prefer-promise-reject-errors
          localStorage.removeItem('accessToken')
          localStorage.removeItem('refreshToken')
          localStorage.removeItem('authority')
          return window.location.reload()
        })
    }
    throw Error(err.response.data.message)
  })
}

export default httpClient
